import styled from 'styled-components';

export const FormItemLabel = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  color: #7f8892;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: -0.03em;

  em {
    color: #ff6661;
    margin: 0;
    padding: 0;
  }
`;

export const FormItemValue = styled.div<{
  direction: 'vertical' | 'horizontal';
}>`
  flex: 1;

  ${({ direction }) => {
    if (direction === 'vertical') return '';
    return `
      display: flex;
      align-items: center;
    `;
  }}

  & > div {
    flex: 1;
  }
`;

export const FormItemWrapper = styled.div<{
  direction: 'vertical' | 'horizontal';
}>`
  display: flex;

  ${({ direction }) => {
    if (direction === 'horizontal') {
      return `
        &:not(:last-of-type) {
          margin-bottom: 32px;
        }
        ${FormItemLabel} {
          width: 100px;
          padding-right: 1rem;
        }
      `;
    }

    return `
      flex-direction: column;
      &:not(:last-of-type) {
        margin-bottom: 24px;
      }
      ${FormItemLabel} {
        padding: 0;
        margin-bottom: 8px;
      }
    `;
  }}
`;
